import Home from "@/pages/Home";
import { Route, Routes } from "react-router-dom";
import UnauthorizedPage from "@/pages/UnauthorizedPage";
import Publications from "@/pages/Publications";
import Faqs from "@/pages/Faqs";
// import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import StrategicRegulatoryPlanning from "@/pages/services/regulatory-services/StrategicRegulatoryPlanning";
import ComprehensiveEctdAndSpl from "@/pages/services/regulatory-services/ComprehensiveEctdAndSpl";
// import PublishingServices from "@/pages/services/regulatory-services/PublishingServices";
import GlobalDrugMasterFileDmf from "@/pages/services/regulatory-services/GlobalDrugMasterFileDmf";
// import Classification from "@/pages/services/regulatory-services/Classification";
import DossierManagement from "@/pages/services/regulatory-services/DossierManagement";
import RegulatoryRepresentationServices from "@/pages/services/regulatory-services/RegulatoryRepresentationServices";
import RegulatorySupportServices from "@/pages/services/regulatory-services/RegulatorySupportServices";
import EnterpriseQualityManagementSystemEQms from "@/pages/services/it-solutions-and-pharma/EnterpriseQualityManagementSystemEQms";
import EctdPublishingSoftware from "@/pages/services/it-solutions-and-pharma/EctdPublishingSoftware";
import PharmacovigilanceAndDrugSafetySoftware from "@/pages/services/it-solutions-and-pharma/PharmacovigilanceAndDrugSafetySoftware";
import ClinicalTrialManagementPlatform from "@/pages/services/it-solutions-and-pharma/ClinicalTrialManagementPlatform";
import ProductDevelopmentApiAndFormulations from "@/pages/services/pharma-project-management/ProductDevelopmentApiAndFormulations";
import AnalyticalDevelopmentAndMicrobiologyServices from "@/pages/services/pharma-project-management/AnalyticalDevelopmentAndMicrobiologyServices";
import BusinessDevelopmentServices from "@/pages/services/pharma-project-management/BusinessDevelopmentServices";
import RegulatoryTrainingPrograms from "@/pages/services/trainings/RegulatoryTrainingPrograms";
import GmpTrainingPrograms from "@/pages/services/trainings/GmpTrainingPrograms";
import CorporateTrainingAndProfessionalDevelopment from "@/pages/services/trainings/CorporateTrainingAndProfessionalDevelopment";
import IntegratedAnalyticalAndProductCharacterizationServices from "@/pages/services/product-development-and-analytical-solutions/IntegratedAnalyticalAndProductCharacterizationServices";
import ProductDevelopmentAndAnalyticalSolutions from "@/pages/services/product-development-and-analytical-solutions/ProductDevelopmentAndAnalyticalSolutions";
import GmpAuditsComplianceAndTrainingServices from "@/pages/services/gmp-audits-and-compliance/GmpAuditsComplianceAndTrainingServices";
import PageLinks from "@/pages/PageLinks";
import OurExpertise from "@/pages/OurExperties";
import TeamSynopsis from "@/pages/TeamSynopsis";

function MainRoute() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />}/>
        <Route path="/publications" element={<Publications />}/>
        <Route path="/faqs" element={<Faqs />}/>
        {/* <Route path="/services" element={<Services />}/> */}
        <Route path="/about-us" element={<About />}/>
        <Route path="/team-synopsis" element={<TeamSynopsis />}/>
        <Route path="/contact-us" element={<Contact />}/>
        <Route path="/our-expertise" element={<OurExpertise />}/>
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/links" element={<PageLinks />} />

        <Route path="/regulatory-services/strategic-regulatory-planning" element={<StrategicRegulatoryPlanning />} />
        <Route path="/regulatory-services/comprehensive-ectd-spl" element={<ComprehensiveEctdAndSpl />} />
        {/* <Route path="/regulatory-services/publishing-services" element={<PublishingServices />} /> */}
        <Route path="/regulatory-services/global-drug-master-file-dmf" element={<GlobalDrugMasterFileDmf />} />
        {/* <Route path="/regulatory-services/classification" element={<Classification />} /> */}
        <Route path="/regulatory-services/dossier-management" element={<DossierManagement />} />
        <Route path="/regulatory-services/regulatory-representation-services" element={<RegulatoryRepresentationServices />} />
        <Route path="/regulatory-services/regulatory-support-services" element={<RegulatorySupportServices />} />

        <Route path="/gmp-audits-and-compliance/gmp-audits-compliance-and-training-services" element={<GmpAuditsComplianceAndTrainingServices />} />

        <Route path="/it-solutions-for-pharma/enterprise-quality-management-system-eqms" element={<EnterpriseQualityManagementSystemEQms />} />
        <Route path="/it-solutions-for-pharma/ectd-publishing-software" element={<EctdPublishingSoftware />} />
        <Route path="/it-solutions-for-pharma/pharmacovigilance-and-drug-safety-software" element={<PharmacovigilanceAndDrugSafetySoftware />} />
        <Route path="/it-solutions-for-pharma/clinical-trial-management-platform" element={<ClinicalTrialManagementPlatform />} />

        <Route path="/pharma-project-management/product-development-api-and-formulations" element={<ProductDevelopmentApiAndFormulations />} />
        <Route path="/pharma-project-management/analytical-development-and-microbiology-services" element={<AnalyticalDevelopmentAndMicrobiologyServices />} />
        <Route path="/pharma-project-management/business-development-services" element={<BusinessDevelopmentServices />} />

        <Route path="/trainings/regulatory-training-programs" element={<RegulatoryTrainingPrograms />} />
        <Route path="/trainings/gmp-training-programs" element={<GmpTrainingPrograms />} />
        <Route path="/trainings/corporate-training-and-professional-development" element={<CorporateTrainingAndProfessionalDevelopment />} />

        <Route path="/product-development-and-analytical-solutions/integrated-analytical-and-product-characterization-services" element={<IntegratedAnalyticalAndProductCharacterizationServices />} />
        <Route path="/product-development-and-analytical-solutions/product-development-and-analytical-solutions" element={<ProductDevelopmentAndAnalyticalSolutions />} />
        <Route path="*" element={<UnauthorizedPage />} />
      </Routes>
    </>
  );
}

export default MainRoute;
